import { useState } from "react";

import { useTranslation } from "@/i18n";
import { PageHeader } from "@/components/shared/page-header";
import { RiskTabs, type RiskTab } from "@/components/risk/risk-tabs";
import { RiskDashboardTab } from "@/components/risk/risk-dashboard-tab";
import { RiskSnapshotsTab } from "@/components/risk/risk-snapshots-tab";
import { RiskSignalsTab } from "@/components/risk/risk-signals-tab";
import { RiskMethodologyTab } from "@/components/risk/risk-methodology-tab";

export default function RiskPage() {
  const { t } = useTranslation();
  const [tab, setTab] = useState<RiskTab>("dashboard");

  return (
    <div className="space-y-6">
      <PageHeader
        title={t("risk.page.title")}
        description={t("risk.page.description")}
      />

      <RiskTabs value={tab} onChange={setTab} />

      {tab === "dashboard" && <RiskDashboardTab />}
      {tab === "snapshots" && <RiskSnapshotsTab />}
      {tab === "signals" && <RiskSignalsTab />}
      {tab === "methodology" && <RiskMethodologyTab />}
    </div>
  );
}
